export const GlobalConstant = Object.freeze({

timeOut: 10000,
timeOutInit: 10000,
timeOutInfo: 40000

})